import {Spinner} from '@translated/babele-react'
import clsx from 'clsx'
import './hubspotOverwrite.css'
import HubspotChatIcon from './HubspotChatIcon'
import {useHubspotChatLauncher} from '~/utils/useHubspotLauncher'

export const HubspotLauncher = () => {
  const {hasTriggeredLoading, hasClicked, hasLoaded, handleHover, handleClick} =
    useHubspotChatLauncher()

  return (
    <div
      id="hubspot-launcher"
      className={clsx('fixed bottom-0 right-0 z-30 p-4', hasLoaded && hasClicked && 'hidden')}
    >
      <button
        aria-label="Open live chat"
        type="button"
        className="flex size-[3.75rem] cursor-pointer items-center justify-center rounded-full hover:scale-105"
        style={{
          backgroundImage:
            'linear-gradient(92.06deg, rgb(94, 106, 184) 42.78%, rgb(43, 122, 191) 100%)'
        }}
        onMouseEnter={handleHover}
        onClick={() => handleClick()}
      >
        {hasTriggeredLoading && hasClicked ? (
          <Spinner className="text-neutral-50" />
        ) : (
          <HubspotChatIcon />
        )}
      </button>
    </div>
  )
}
